module.exports = __webpack_public_path__ + "media/img/frontend_application/document-blank-ac10c56bd5feec630dc98bad8561b743.png";